/**
 * created by xcc on 2021/10/25
 * 新媒体列表模式组件
 */
import React from 'react';
import {Table} from "antd";
import Scrollbars from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";

export default class NewMediaManageList extends BaseComponent {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            NewMediaListData: [], //数据
            searchValue: ""
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        //历史发布权限
        let historyPublishLimits = this.permissionCheck("pms:newsMediaManage:historyPublish");
        //转交媒体
        let transferLimits = this.permissionCheck("pms:newsMediaManage:transferMedia");
        const ListPageColumns = [
            {
                title: '媒体名称',
                key: 'name',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div onClick={()=>{
                            this.props.onTableClickItem(record)
                        }} style={{
                            cursor: "pointer",
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>{record.name}</div>
                    )
                }
            },
            {
                title: '媒体平台',
                dataIndex: 'newMediaTypeName',
                key: 'newMediaTypeName',
                ellipsis: true,
            },
            {
                title: '主责单位',
                key: 'mainDeptName',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>{record.mainDeptName}</div>
                    )
                }
            },
            {
                title: '媒体状态',
                key: 'status',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>{record.statusName === "已备案" ? "审核通过" : record.statusName}</div>
                    )
                }
            },
            {
                title: '负责人',
                key: 'leader',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>{record.leader}</div>
                    )
                }
            },
            {
                title: '操作',
                key: 'operate',
                ellipsis: true,
                render: (record) => {
                    return (
                        <div style={{color: "#1890ff", }}>
                            {(historyPublishLimits) ?
                                <span style={{marginRight: "10px", cursor: "pointer"}}
                                      onClick={() => this.historyPublish(record)}>历史发布</span> : null
                            }
                            {(transferLimits && record.createById === window.top.currentUser.id) ?
                                <span style={{cursor: "pointer"}} onClick={() => {
                                    this.transferToMedia(record)
                                }}>转交媒体</span> : null
                            }
                        </div>
                    )
                }
            }
        ];
        let height = document.body.clientHeight - 251;
        let scrollHeight = document.body.scrollHeight;
        if(scrollHeight < 852 || (window.screen.height >= 768 && window.screen.height < 1080)){
            height = window.innerHeight - 291;
        }
        return (
            <div key={this.props.loadListKey} id={"table"} style={{padding: "20px", background: 'white', borderRadius: "5px"}}>
                <Scrollbars
                    autoHide
                    autoHeight
                    autoHeightMax={height}
                >
                    <Table
                        rowKey={record=>record.id} columns={ListPageColumns} dataSource={this.props.listData} pagination={false}
                    />
                    <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                    #table .ant-table-body{border:none !important;}
                    #table .ant-table-tbody > tr{cursor: pointer;}
                `}</style>
                </Scrollbars>
            </div>
        )
    }

    //转交媒体
    transferToMedia(record) {
        this.props.getMtSqrInfos(record);
    }

    //历史发文
    historyPublish(item) {
        this.props.historyPublish(item);
    }
}